import BgImage from 'assets/images/bg.webp'
import styled from 'styled-components/macro'

const BgWrapper = styled.img`
  position: fixed;
  left: 0;
  top: 0;
  z-index: -1;
  width: 100vw;
  height: 100vh;
  object-position: center;
  object-fit: cover;
`

export const BackgroundWrapper = () => <BgWrapper src={BgImage} alt="background image" />
